import "./leaderboard-table-item.css";

const LeaderBoardTableItem = ({ team, currentTeam }) => {
  return (
    <tr
      className={currentTeam.team_id === team.team_id ? "current-position" : ""}
      data-testid="leaderboard-table-item"
    >
      <td className="position" data-testid="position">
        {team.position}
      </td>
      <td className="team-name" data-testid="team-name">
        {team.team_name}
      </td>
      <td data-testid="victories">{team.victories}</td>
      <td data-testid="losses">{team.losses}</td>
      <td data-testid="points">{team.points}</td>
    </tr>
  );
};

export default LeaderBoardTableItem;
